/**
 * @deprecated we want to avoid using this service anymore.
 * We should use the `100dvh` unit instead with a top padding to account for the toolbar.
 */
import { onBeforeUnmount, onMounted, ref } from "vue";

/**
 * Compute the height available without scrolling after a given element.
 * @param afterSelector a css selector
 */
export function useRemainingHeight(afterSelector: string) {
  const remainingHeight = ref(0);

  function computeRemainingHeight() {
    const e = document.querySelector(afterSelector) as HTMLElement | null;
    if (e !== null) {
      remainingHeight.value = window.innerHeight - e.offsetTop;
    }
  }

  const resizeObserver = new ResizeObserver(() => {
    computeRemainingHeight();
  });

  onMounted(() => {
    computeRemainingHeight();
    resizeObserver.observe(document.body);
  });

  onBeforeUnmount(() => {
    resizeObserver.unobserve(document.body);
  });

  return { remainingHeight, computeRemainingHeight };
}
